"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_TYPE_LABELS = exports.NOTIFICATION_TYPE_ICONS = void 0;
var NOTIFICATION_TYPE_LABELS = {
    ALARM: "Alarm",
    TASK: "Task",
    INTEGRATION: "Integration",
    BILLING: "Billing",
    SECURITY: "Account security",
    SYSTEM: "System",
};
exports.NOTIFICATION_TYPE_LABELS = NOTIFICATION_TYPE_LABELS;
var NOTIFICATION_TYPE_ICONS = {
    ALARM: "solar:danger-triangle-linear",
    TASK: "solar:checklist-minimalistic-linear",
    INTEGRATION: "solar:plug-circle-linear",
    BILLING: "solar:card-linear",
    SECURITY: "solar:shield-keyhole-linear",
    SYSTEM: "solar:info-circle-linear",
};
exports.NOTIFICATION_TYPE_ICONS = NOTIFICATION_TYPE_ICONS;
